import React, { Component } from 'react'
// components
import { icons } from './icons'
import { Button } from 'components/ui/Button'
import { FieldInput } from 'components/Form/Fields/FieldInput'
import Input from 'components/Form/Input'
// redux
import { compose } from 'redux'
import { InjectedFormProps, reduxForm } from 'redux-form'
// types
import { ComposeType } from 'types/common'
import { Classes } from 'jss'
// styles
import injectSheet from 'react-jss'
import { sheet } from './sheet'
// utils
import { createPasswordRecruiter } from 'pages/Auth/validation'
import { upper } from 'lib/normalize'
import { StateSignUp } from '../SignUp/types'
import { FieldSelect } from '../../../components/Form/Fields/FieldSelect'
import Select from '../../../components/Form/Select'
import BackgroundWithFigures from '../../../components/common/BackgroundWithFigures'
import CheckBox from '../../../components/Form/CheckBox'
import { FieldCheckBox } from '../../../components/Form/Fields/FieldCheckBox'
import { push, Push } from 'connected-react-router'
import { connect } from 'react-redux'
import { StateInterface } from '../../../types/state'
import { modalIsLoadingSelector } from '../../../domain/loading'

interface FormValuesInterface {
  firstName: string
  lastName: string
  password: string
  confirmationPassword: string
}

interface OwnProps {
  classes: Classes
  acceptInvitation: (data: FormValuesInterface) => void
  acceptingRole: StateSignUp
  push?: Push
}

type Props = InjectedFormProps<FormValuesInterface> & OwnProps

class CreatePassword extends Component<Props> {
  submit = (data: FormValuesInterface) => {
    this.props.acceptInvitation(data)
  }

  logIn = () => {
    if (this.props.push) this.props.push('/log-in')
  }

  render() {
    const { classes, error, handleSubmit, submitFailed, acceptingRole } = this.props
    const countryOptions = [
      { value: 'india', label: 'India' },
      { value: 'united states', label: 'USA' }
    ]
    const roleLabel =
      acceptingRole === StateSignUp.Recruiter
        ? 'Recruiter'
        : acceptingRole === StateSignUp.Candidate
        ? 'Candidate'
        : 'User'

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <div className={classes.content}>
          <div className={`d-flex column  ${classes.textLeft}`}>
            <BackgroundWithFigures />

            <div>
              <h3>Welcome to Skilent</h3>
              <p>You’ve been invited to join Skilent as a {roleLabel}. </p>
              <p className={'text-14 text-dark'}>
                Please complete your details and set a password to create your account.
              </p>
            </div>
            <div>
              <h4>Tips for strong password:</h4>
              <div className={`d-flex ${classes.iconBlocksWrapper}`}>
                {icons.map((el, j) => (
                  <div className={classes.iconBlock} key={j}>
                    {el.icon}
                    <p className={'text-14 text-bold text-dark'}>{el.name}</p>
                    <div className={'text-14  '}>{el.text}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={`${classes.form} flex-center-justify column`}>
            <div className={`${classes.formTitle} text-18 text-semibold text-dark`}>
              {acceptingRole === StateSignUp.Recruiter && 'Sign up as Recruiter'}
              {acceptingRole === StateSignUp.Candidate && 'Sign up as Candidate'}
            </div>
            {submitFailed && error && <div className={classes.formError}>{error}</div>}
            <div className={`${classes.name} d-flex`}>
              <FieldInput
                name="firstName"
                type="text"
                component={Input}
                title="First name"
                normalize={upper}
                placeholder="Enter your name.."
                required
              />
              <FieldInput
                name="lastName"
                type="text"
                component={Input}
                title="Last name"
                normalize={upper}
                placeholder="Enter last name.."
                required
              />
            </div>
            {acceptingRole === StateSignUp.Candidate && (
              <FieldSelect
                name="country"
                title="Country"
                component={Select}
                isSearchable={false}
                options={countryOptions}
                isMulti={false}
                required
              />
            )}
            <FieldInput
              name="password"
              type="password"
              component={Input}
              title="Password"
              placeholder="must include at least 8 symbols"
              isPassword={true}
              required
            />
            <FieldInput
              name="confirmationPassword"
              type="password"
              component={Input}
              title="Repeat password"
              isPassword={true}
              placeholder="must include at least 8 symbols"
              required
            />
            <FieldCheckBox
              name="accept"
              component={CheckBox}
              required
              label={
                <span className={`${classes.linkText} text-main text-14`}>
                  I accept{' '}
                  <a className="text-main text-16" href="/terms_and_conditions" target="_blank">
                    Terms and Conditions
                  </a>
                </span>
              }
            />
            <div className={classes.buttonGroup}>
              <Button
                type="button"
                fill
                onClick={this.logIn}
                label="ALREADY HAVE ACCOUNT"
                variant="outlined"
              />
              <Button type="submit" fill label="CREATE ACCOUNT" />
            </div>
          </div>
        </div>
      </form>
    )
  }
}

export default compose<ComposeType<Props>>(
  connect(
    (state: StateInterface) => ({
      modalIsLoading: modalIsLoadingSelector(state)
    }),
    {
      push
    }
  ),
  reduxForm({
    form: 'create-password-recruiter',
    validate: createPasswordRecruiter,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  }),
  injectSheet(sheet)
)(CreatePassword)
